import type { DeploymentPhaseResult, UniswapDeployment } from "./types";

/** Hooks fired during deployment lifecycle */
export interface DeploymentHooks {
  /** Called before any deployment begins */
  beforeDeploy?: (config: {
    chainId: number;
    rpcUrl: string;
  }) => void | Promise<void>;
  /** Called after each phase completes (accepts any address type) */
  afterPhase?: (result: DeploymentPhaseResult<unknown>) => void | Promise<void>;
  /** Called after all phases complete */
  afterDeploy?: (deployment: UniswapDeployment) => void | Promise<void>;
  /** Called before each seed step (tokens, liquidity, swaps, agents) */
  beforeSeedStep?: (step: string) => void | Promise<void>;
  /** Called before each individual seed action (e.g., "Deploying USDC", "V3 buy ETH") */
  onSeedAction?: (action: string) => void | Promise<void>;
  /** Called after seeding completes */
  afterSeed?: (deployment: UniswapDeployment) => void | Promise<void>;
  /** Called on error during any phase */
  onError?: (phase: number, error: Error) => void | Promise<void>;
}

/** No-op hooks (default) */
export const EMPTY_HOOKS: Required<DeploymentHooks> = {
  /* eslint-disable @typescript-eslint/no-empty-function */
  beforeDeploy: () => {},
  afterPhase: () => {},
  afterDeploy: () => {},
  beforeSeedStep: () => {},
  onSeedAction: () => {},
  afterSeed: () => {},
  onError: () => {},
  /* eslint-enable @typescript-eslint/no-empty-function */
};

/** Merge partial hooks with defaults */
export function mergeHooks(hooks?: DeploymentHooks): Required<DeploymentHooks> {
  return { ...EMPTY_HOOKS, ...hooks };
}
